/**
 * Filter popup tokens (used by FilterPopup, PropertyPickerPopover,
 * MetricBlock and every component that themes the agent/global/event
 * filter chrome).
 *
 * All values resolve through CSS variables so the popup flips with
 * `data-theme="dark"` on <html>. Adjust palette in trodoColors.js only.
 */
import { trodoAnalyticsTheme } from "features/analytics/studio/theme";
import { primaryAlpha } from "shared/theme/trodoColors";

export const activityFilterPopupTheme = {
  ...trodoAnalyticsTheme,
  border:        "var(--border-default)",
  bgRaised:      "var(--surface-raised)",
  bgNav:         "var(--surface-raised)",
  bgDescription: "var(--surface-sunken)",
  textWarmMuted: "var(--text-muted)",
  navActiveBg:   "var(--surface-hover)",
  rowHoverBg:    "var(--surface-hover)",
  badgeTintBg:   primaryAlpha(0.12),
};
